import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch, Ref } from 'vue-property-decorator';
import { getDetails, editDetails, addDetails, getGroupNameAry } from '@blade-sxp/its-management/api/index'; // 接口
import { DialogType } from '@blade-sxp/its-management/interfaces/index';
let default_1 = class default_1 extends Vue {
    dialogVisible;
    type;
    deviceId;
    deviceGroupName;
    addDeviceSuccess;
    changeType;
    deviceForm;
    loading = false;
    onTypeChange() {
        if (this.type !== 'add') {
            this.getDeviceInfo();
        }
    }
    subLoading = false;
    formData = {
        protocolType: 'DAHUA-DEV',
        rtspAddress: '',
        ip: '',
        groupId: '',
        groupName: '',
        dahuaDirectionType: '',
        username: '',
        password: '',
    };
    getGroupName = [];
    groupArr = [];
    // 组名称 树结构相关
    selectTree = [];
    defaultProps = {
        children: 'children',
        label: 'name',
    };
    props = {
        value: 'name',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        emitPath: false, // 只返回该节点的值
    };
    // 提交按钮的禁用
    get subDisable() {
        const { ip, groupId } = this.formData;
        if (ip && groupId) {
            return false;
        }
        else {
            return true;
        }
    }
    // form校验
    get rules() {
        return {
            ip: [
                {
                    required: true,
                    message: this.$t('device.IPAddress'),
                    trigger: ['blur', 'change'],
                    validator: (rule, value, callback) => {
                        if (!/([0-9]\.?)+$/.test(this.formData.ip)) {
                            return callback(new Error(this.$t('device.IPAddress').toString()));
                        }
                        callback();
                    },
                },
            ],
            groupId: [{ required: true, message: `${this.$t('groupNameHolder')}`, trigger: ['blur', 'change'] }],
        };
    }
    // 是否可编辑
    get shouldDisable() {
        if (this.type === 'view') {
            return true;
        }
        else {
            return false;
        }
    }
    get getToolsBtn() {
        if (this.type === 'view') {
            return true;
        }
        else {
            return false;
        }
    }
    // Direction 待选项
    get getDirection() {
        return [
            { name: this.$t('in'), value: 'IN' },
            { name: this.$t('out'), value: 'OUT' },
            { name: this.$t('parking'), value: 'PARKING' },
        ];
    }
    // dialog 标题
    get returnTitle() {
        if (this.type === 'edit') {
            return `${this.$t('editDevice')}`;
        }
        else if (this.type === 'view') {
            return `${this.$t('deviceDetails')}`;
        }
        else {
            return `${this.$t('deviceAdd')}`;
        }
    }
    // 页面加载完执行
    mounted() {
        this.getGroupNameAryFn();
    }
    getGroupNameAryFn() {
        getGroupNameAry({}).then((res) => {
            const treeData = res.trees;
            if (treeData) {
                this.recursiveFunction(res.trees);
                this.getGroupName = this.dealAreaTree(treeData);
                let groupId = '';
                let groupName = '';
                if (this.deviceGroupName !== 'Ungrouped Device') {
                    groupName = treeData[0].name;
                    groupId = treeData[0].id;
                }
                if (this.type === 'add') {
                    const dahuaDirectionType = 'PARKING';
                    this.formData = Object.assign(this.formData, { groupName, groupId, dahuaDirectionType });
                }
            }
            else {
                this.getGroupName = [];
            }
        });
    }
    recursiveFunction(trees) {
        let that = this;
        const getStr = function (list) {
            list.forEach(function (row) {
                if (row.children) {
                    that.groupArr.push(row);
                    getStr(row.children);
                }
            });
        };
        getStr(trees);
    }
    // 处理地区树数据结构
    dealAreaTree(tree) {
        const newTree = tree.map((i) => {
            let children = i.children;
            if ((children && children.length === 0) || !children) {
                delete i.children;
            }
            else {
                this.dealAreaTree(children);
            }
            return i;
        });
        return newTree;
    }
    handleChange() {
        this.formData.groupId = String(this.groupArr.find((item) => {
            return item.name === this.formData.groupName;
        })?.id);
        this.$refs.queueReportCascader.dropDownVisible = false;
    }
    // 树结构点击事件
    handleNodeClick(data) {
        this.formData.groupId = data.id;
        this.formData.groupName = data.name;
    }
    // 关闭窗口
    handleClose() {
        this.$emit('update:dialogVisible', false);
    }
    // 切换编辑
    handleEdit() {
        this.$emit('update:type', DialogType.EDIT);
    }
    // 确认提交
    handleConfirm() {
        this.deviceForm?.validate().then((res) => {
            const params = Object.assign({}, this.formData);
            if (this.type === 'edit') {
                this.editDevice(params);
            }
            if (this.type === 'add') {
                this.addDevice(params);
            }
        });
    }
    // 编辑保存
    editDevice(params) {
        try {
            this.subLoading = true;
            editDetails(params)
                .then(() => {
                // this.$message.success(`${this.$t('saveSuccessfully')}`);
                this.$message({
                    customClass: 'success-message',
                    message: this.$t('saveSuccessfully').toString(),
                    type: 'success',
                    showClose: true,
                });
                this.handleClose();
                this.$emit('refurbish-table');
            })
                .catch((err) => {
                this.$message({ message: err, type: 'error' });
            })
                .finally(() => {
                this.subLoading = false;
            });
        }
        catch (error) {
            console.log('editDevice err', error);
            this.subLoading = false;
        }
    }
    // 新增
    addDevice(params) {
        try {
            this.subLoading = true;
            addDetails(params)
                .then(() => {
                // this.$message.success(`${this.$t('saveSuccessfully')}`);
                this.$message({
                    customClass: 'success-message',
                    message: this.$t('saveSuccessfully').toString(),
                    type: 'success',
                    showClose: true,
                });
                this.handleClose();
                this.$emit('refurbish-table');
            })
                .catch((err) => {
                this.$message({ message: err, type: 'error' });
            })
                .finally(() => {
                this.subLoading = false;
            });
        }
        catch (error) {
            console.log('addDevice err', error);
            this.subLoading = false;
        }
    }
    // 获取设备详情
    getDeviceInfo() {
        getDetails(this.deviceId).then((res) => {
            const rtspAddress = this.getRtsp(res);
            this.formData = Object.assign({}, res, {
                dahuaDirectionType: res.dahuaDirectionType || res.direction,
                rtspAddress,
            });
        });
    }
    setRtsp() {
        const rtspAddress = this.getRtsp(this.formData);
        this.formData = Object.assign(this.formData, {
            rtspAddress,
        });
    }
    getRtsp(obj) {
        const { username, password, ip } = obj;
        return `rtsp://${username}:${password}@${ip}/cam/realmonitor?channel=1&subtype=0`;
    }
};
__decorate([
    Prop()
], default_1.prototype, "dialogVisible", void 0);
__decorate([
    Prop()
], default_1.prototype, "type", void 0);
__decorate([
    Prop()
], default_1.prototype, "deviceId", void 0);
__decorate([
    Prop()
], default_1.prototype, "deviceGroupName", void 0);
__decorate([
    Prop()
], default_1.prototype, "addDeviceSuccess", void 0);
__decorate([
    Prop()
], default_1.prototype, "changeType", void 0);
__decorate([
    Ref()
], default_1.prototype, "deviceForm", void 0);
__decorate([
    Watch('type', { immediate: true })
], default_1.prototype, "onTypeChange", null);
default_1 = __decorate([
    Component({
        name: 'model',
        components: {},
        i18n: {
            messages: {
                en: {
                    save: 'Save',
                    edit: 'Edit',
                    submit: 'Submit',
                    cancel: 'Cancel',
                    deviceAdd: 'Add Device',
                    deviceAddSuccess: 'Add Device Success',
                    editDevice: 'Edit Device',
                    deviceDetails: 'Device Details',
                    protocolType: 'Protocol Type',
                    protocolTypeHolder: 'Please select ProtocolType',
                    ip: 'IP',
                    groupName: 'Group Name',
                    groupNameHolder: 'please select',
                    direction: 'Direction of Inlet and Outlet',
                    directionHolder: 'please select',
                    username: 'Username',
                    usernameHolder: 'please Enter Username',
                    password: 'Password',
                    passwordHolder: 'please Enter Password',
                    in: 'IN',
                    out: 'OUT',
                    parking: '-',
                    saveSuccessfully: 'Save Successfully',
                    rtspAddress: 'RTSP Address',
                    rtspAddressHolder: 'please enter RTSP Address',
                },
                zh: {
                    save: '保存',
                    edit: '编辑',
                    submit: '确定',
                    cancel: '取消',
                    deviceAdd: '添加设备',
                    deviceAddSuccess: '添加设备成功',
                    editDevice: '设备编辑',
                    deviceDetails: '设备详情',
                    protocolType: '协议类型',
                    protocolTypeHolder: '请输入协议类型',
                    ip: 'IP地址（IPv4/IPv6）',
                    groupName: '组名称',
                    groupNameHolder: '请选择组名',
                    direction: '进、出口方向',
                    directionHolder: '请选择进、出口方向',
                    username: '用户名',
                    usernameHolder: '请输入用户名',
                    password: '密码',
                    passwordHolder: '请输入密码',
                    in: '进',
                    out: '出',
                    parking: '-',
                    saveSuccessfully: '保存成功',
                    rtspAddress: 'RTSP 地址',
                    rtspAddressHolder: '请输入RTSP 地址',
                },
            },
        },
    })
], default_1);
export default default_1;
